// extracted by mini-css-extract-plugin
export default {"spiderContainer":"Results_spiderContainer__fc1rl","tableContainer":"Results_tableContainer__kvgo2","chartContainer":"Results_chartContainer__sT4YL"};